import React, { useState } from "react";
import { Row, Col, Button, Modal } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import useViewportWidth from "../../hooks/useViewportWidth";

// const { useToken } = theme;

const ANALYSIS_OPTIONS = [
  {
    key: "fresher",
    title: "Fresher",
    subtitle: "Students, recent grads, and early-career candidates",
    accent: "#16a34a",
    surface: "#f0fdf4",
    border: "#bbf7d0",
    points: [
      "Internships, live projects, certifications, and college work",
      "Achievements, hackathons, leadership, and measurable outcomes",
      "Skills, learning potential, and role-fit instead of full-time history",
    ],
    buttonLabel: "Analyze as Fresher",
  },
  {
    key: "experience",
    title: "Experienced",
    subtitle: "Working professionals with full-time experience",
    accent: "#2563eb",
    surface: "#eff6ff",
    border: "#bfdbfe",
    points: [
      "Career growth, ownership, stack depth, and role relevance",
      "Quantified impact, promotions, and business outcomes",
      "Stronger ATS alignment for experienced job applications",
    ],
    buttonLabel: "Analyze as Experienced",
  },
];

export default function WelcomePage() {
  const navigate = useNavigate();
  const [audienceModalOpen, setAudienceModalOpen] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const viewportWidth = useViewportWidth();
  const isMobile = viewportWidth <= 480;
  const isTablet = viewportWidth <= 1024;
  const isCompact = viewportWidth <= 1024;
  const compactPremiumAccent = "#C79A58";
  const compactPremiumAccentGradient =
    "linear-gradient(135deg, #F1D09A 0%, #C79A58 52%, #A8713C 100%)";
  const desktopPremiumFont = "'Avenir Next', 'Helvetica Neue', Arial, sans-serif";
  const desktopPremiumButtonGradient =
    "linear-gradient(135deg, #D8B06A 0%, #BC8A49 56%, #8A6136 100%)";
  const desktopPremiumLabelColor = "#F0D2A0";
  const desktopPremiumSoftSurface = "#F7F2E8";
  const desktopPremiumSoftBorder = "#E2D5C4";
  const desktopPremiumSoftText = "#282523";
  const desktopPremiumDarkButtonGradient =
    "linear-gradient(135deg, #31415D 0%, #1E2A41 100%)";
  // const { token } = useToken();

  const handleAudienceSelect = (audience) => {
    sessionStorage.setItem("experienceLevel", audience);
    setAudienceModalOpen(false);
    navigate("/dashboard");
  };

  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          background: "#020617",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: isMobile ? 18 : isTablet ? 24 : 40,
        }}
      >
        <Row justify="center">
          <Col style={{ textAlign: "center", maxWidth: isTablet ? 720 : 900 }}>

            {/* Tag */}
            <div
              style={{
                color: isCompact ? "#94a3b8" : desktopPremiumLabelColor,
                marginBottom: 16,
                fontFamily: isCompact ? undefined : desktopPremiumFont,
                fontWeight: isCompact ? undefined : 700,
                letterSpacing: isCompact ? undefined : "0.14em",
                textTransform: isCompact ? undefined : "uppercase",
              }}
            >
              ✨ AI-Powered Resume Analysis
            </div>

            {/* Title */}
            <h1
              style={{
                fontSize: isMobile ? 34 : isTablet ? 44 : 56,
                fontWeight: 700,
                lineHeight: 1.2,
                background: "linear-gradient(90deg,#38bdf8,#a855f7)",
                WebkitBackgroundClip: "text",
                color: "transparent",
              }}
            >
              Optimize Your Resume
            </h1>

            {/* Subtitle */}
            <p
              style={{
                marginTop: 16,
                fontSize: isMobile ? 15 : isTablet ? 17 : 18,
                color: "#94a3b8",
                lineHeight: 1.7,
                padding: isMobile ? "0 6px" : 0,
              }}
            >
              Upload your resume, get ATS score, keyword gaps and AI insights instantly.
            </p>

            {/* CTA Button */}
            <div
              style={{
                marginTop: isMobile ? 28 : 40,
                display: "flex",
                gap: 16,
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              {/* CTA */}
              <Button
                type="primary"
                size="large"
                style={{
                  height: 50,
                  padding: isCompact ? "0 28px" : "0 50px",
                  fontSize: 16,
                  borderRadius: 10,
                  background: isCompact
                    ? "linear-gradient(90deg,#38bdf8,#a855f7)"
                    : desktopPremiumButtonGradient,
                  border: isCompact ? "none" : "1px solid rgba(232, 210, 174, 0.7)",
                  color: isCompact ? "#ffffff" : "#FFF9F1",
                  fontFamily: isCompact ? undefined : desktopPremiumFont,
                  fontWeight: isCompact ? 600 : 700,
                  boxShadow: isCompact
                    ? undefined
                    : "0 18px 40px rgba(188, 138, 73, 0.22)",
                  width: isMobile ? "100%" : "auto",
                }}
                onClick={() => setAudienceModalOpen(true)}
              >
                Analyze My Resume
              </Button>

              {/* ✅ NEW WATCH DEMO BUTTON */}
              <Button
                size="large"
                style={{
                  height: 50,
                  padding: isCompact ? "0 20px" : "0 30px",
                  fontSize: 16,
                  borderRadius: 10,
                  background: isCompact ? undefined : desktopPremiumSoftSurface,
                  borderColor: isCompact ? undefined : desktopPremiumSoftBorder,
                  color: isCompact ? undefined : desktopPremiumSoftText,
                  fontFamily: isCompact ? undefined : desktopPremiumFont,
                  fontWeight: isCompact ? undefined : 700,
                  width: isMobile ? "100%" : "auto",
                }}
                onClick={() => setShowVideo(true)}
              >
                ▶ Watch Demo
              </Button>
            </div>

            {/* Small Text */}
            <div
              style={{
                marginTop: 16,
                color: "#64748b",
              }}
            >
              Takes less than 10 seconds ⚡
            </div>
          </Col>
        </Row>
      </div>
              {showVideo && (
  <div
    style={{
      position: "fixed",
      top: isCompact ? 16 : 30,
      right: isCompact ? 16 : 30,
      left: isCompact ? 16 : "auto",
      width: isCompact ? "auto" : 380,
      background: "#000",
      borderRadius: 16,
      boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
      zIndex: 1000,
      overflow: "hidden", // ✅ important
    }}
  >
    {/* ✅ CLOSE BUTTON */}
    <div
      onClick={() => setShowVideo(false)}
      style={{
        position: "absolute",
        top: 8,
        right: 8,
        width: 30,
        height: 30,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(0,0,0,0.7)", // better visibility
        color: "#fff",
        borderRadius: "50%",
        cursor: "pointer",
        zIndex: 10, // ✅ must be higher than video
      }}
    >
      ✕
    </div>

    {/* VIDEO */}
    <video
      width="100%"
      height="220"
      controls
      autoPlay
      muted
      style={{
        display: "block",
        borderRadius: 16,
      }}
    >
      <source src="/demovideoiq.mp4" type="video/mp4" />
    </video>
  </div>
)}
      <Modal
        open={audienceModalOpen}
        footer={null}
        centered
        width={isTablet ? "calc(100vw - 24px)" : 920}
        onCancel={() => setAudienceModalOpen(false)}
      >
        <div style={{ padding: isCompact ? "10px 6px 6px" : "8px 4px 4px" }}>
          {isCompact ? (
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                padding: "6px 10px",
                borderRadius: 999,
                background: "#F0E5D6",
                color: "#7F5A2B",
                fontSize: 11,
                fontWeight: 700,
                letterSpacing: "0.12em",
                textTransform: "uppercase",
              }}
            >
              Premium Lens
            </div>
          ) : null}
          <div
            style={{
              fontSize: isCompact ? 30 : 28,
              fontWeight: 700,
              color: "#0f172a",
              marginTop: isCompact ? 16 : 0,
              fontFamily: isCompact ? "Georgia, 'Times New Roman', serif" : undefined,
            }}
          >
            How should we analyze your resume?
          </div>
          <div style={{ marginTop: 10, fontSize: isCompact ? 15 : 15, lineHeight: 1.65, color: "#475569" }}>
            {isCompact
              ? "Choose the scoring lens that fits your profile. You can change this later, so the decision stays low-risk."
              : "Choose the lens that fits your profile. If you are a fresher, we will weigh internships, projects, skills, and achievements more heavily than full-time work history."}
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: isTablet ? "1fr" : "repeat(2, minmax(0, 1fr))",
              gap: 18,
              marginTop: 24,
            }}
          >
            {ANALYSIS_OPTIONS.map((option) => (
              <div
                key={option.key}
                style={{
                  border: isCompact
                    ? `1px solid ${option.key === "fresher" ? "#E6CFB0" : "#D8DDE8"}`
                    : `1px solid ${option.border}`,
                  borderRadius: isCompact ? 24 : 20,
                  background: isCompact
                    ? option.key === "fresher"
                      ? "#FFF8F0"
                      : "#FBFBFD"
                    : option.surface,
                  padding: 22,
                  boxShadow: "0 16px 40px rgba(15, 23, 42, 0.06)",
                }}
              >
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 8,
                    padding: "6px 10px",
                    borderRadius: 999,
                    background: "#ffffff",
                    color: isCompact
                      ? option.key === "fresher"
                        ? "#8A6A3B"
                        : "#6B7C91"
                      : option.key === "fresher"
                        ? "#B98549"
                        : "#6C7C96",
                    fontSize: 11,
                    fontWeight: 700,
                    letterSpacing: isCompact ? "0.12em" : "normal",
                    textTransform: isCompact ? "uppercase" : "none",
                    fontFamily: isCompact ? undefined : desktopPremiumFont,
                  }}
                >
                  <CheckCircleFilled />
                  {isCompact ? `${option.title} Lens` : option.title}
                </div>

                <div
                  style={{
                    marginTop: 16,
                    fontSize: 24,
                    fontWeight: 700,
                    color: "#0f172a",
                    fontFamily: isCompact ? "Georgia, 'Times New Roman', serif" : undefined,
                  }}
                >
                  {isCompact
                    ? option.key === "fresher"
                      ? "Projects, learning, and trajectory first"
                      : "Impact, ownership, and progression first"
                    : option.title}
                </div>
                <div style={{ marginTop: 6, fontSize: 14, color: "#475569" }}>
                  {isCompact ? option.points[0] : option.subtitle}
                </div>

                <div style={{ marginTop: 18, display: "grid", gap: 12 }}>
                  {option.points.map((point) => (
                    <div
                      key={point}
                      style={{
                        display: "grid",
                        gridTemplateColumns: "18px 1fr",
                        gap: 10,
                        alignItems: "start",
                        color: "#1e293b",
                        fontSize: 14,
                        lineHeight: 1.6,
                      }}
                    >
                      <CheckCircleFilled style={{ color: option.accent, marginTop: 2 }} />
                      <span>{point}</span>
                    </div>
                  ))}
                </div>

                <Button
                  type="primary"
                  block
                  size="large"
                  style={{
                    marginTop: 22,
                    height: isCompact ? 42 : 46,
                    borderRadius: isCompact ? 18 : 12,
                    background: isCompact
                      ? option.key === "fresher"
                        ? compactPremiumAccentGradient
                        : "#2F405A"
                      : option.key === "fresher"
                        ? desktopPremiumButtonGradient
                        : desktopPremiumDarkButtonGradient,
                    borderColor: isCompact
                      ? option.key === "fresher"
                        ? compactPremiumAccent
                        : "#2F405A"
                      : option.key === "fresher"
                        ? "#B98549"
                        : "#31415D",
                    color: isCompact
                      ? option.key === "fresher"
                        ? "#1B1612"
                        : "#FFFFFF"
                      : option.key === "fresher"
                        ? "#FFF9F1"
                        : "#F6E8D1",
                    boxShadow: "none",
                    fontWeight: 700,
                    fontFamily: isCompact ? undefined : desktopPremiumFont,
                  }}
                  onClick={() => handleAudienceSelect(option.key)}
                >
                  {isCompact
                    ? option.key === "fresher"
                      ? "Choose Fresher"
                      : "Choose Experienced"
                    : option.buttonLabel}
                </Button>
              </div>
            ))}
          </div>
        </div>
      </Modal>
    </>
  );
}
